import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="w-full bg-white-soft py-10 md:py-24 px-5" data-id="element-426">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-2xl mx-auto" data-id="element-427">
        <p className="font-body text-lg md:text-xl text-brown-medium leading-relaxed mb-5 md:mb-8" data-id="element-428">
          Miras el cepillo cada mañana con el mismo nudo en el estómago. Sabes
          que hay más cabellos ahí de los que deberían. Luego, pasas la mano por
          tu coronilla y sientes ese picor punzante, esa irritación que parece
          avisarte de que otra zona se está quedando vacía.
        </p>

        <div className="border-l-4 border-gold pl-5 py-2 my-6 md:my-10" data-id="element-429">
          <p className="font-heading text-xl md:text-2xl text-brown-dark leading-relaxed italic" data-id="element-430">
            A los 60 años, el mundo te dice que "es la edad" y que debes
            aceptarlo.
          </p>
        </div>

        <p className="font-body text-lg md:text-xl text-brown-medium leading-relaxed" data-id="element-431">
          Pero tu cabello no está muriendo por vejez; está bajo un{' '}
          <strong className="text-brown-dark font-semibold" data-id="element-432">
            incendio invisible de micro-inflamación
          </strong>{' '}
          que obliga al folículo a soltar la hebra para sobrevivir.
        </p>
      </motion.div>
    </section>;
}